/**
 * Push
 * A module is meant to be rendered by pages
 * (maybe wrapped into one or more Layouts)
 * A module should render components, passinng data to them.
 * @class Push
 * @param {object} props - Props
 */

import React, { useMemo } from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import classNames from "classnames";
import { Link } from "./link";
import slugify from "@sindresorhus/slugify";

const Push = ({ data, isFirst }) => {
  const { push } = data;

  const images = useMemo(
    () =>
      push?.image?.node
        ? withArtDirection(getImage(push.image.node), [
            {
              media: "(max-width: 800px)",
              image: getImage(push.image.nodeMobile),
            },
          ])
        : null,
    [push]
  );
  return (
    <>
      {data?.anchor?.anchorTitleDesktopPush && (
        <span id={slugify(data.anchor.anchorTitleDesktopPush)} className="tabs__scroll-anchor" />
      )}
      <div
        className={classNames(
          "editorialPush",
          `editorialPush--${push?.colour?.[0]}`,
          `editorialPush--${push?.layout?.[0]}`
        )}
      >
        <div className="editorialPush__content">
          <div className="inner">
            {push?.pretitle ? (
              <div className="editorialPush__pre-title heading-xs-medium">{push.pretitle}</div>
            ) : null}
            {push?.title && isFirst ? (
              <h1 className="editorialPush__title heading-sm-semibold lg-heading-md-semibold">
                {push.title}
              </h1>
            ) : push?.title ? (
              <div className="editorialPush__title heading-sm-semibold lg-heading-md-semibold">
                {push.title}
              </div>
            ) : null}
            {push?.abstractHtml ? (
              <div
                className="editorialPush__text-html text-sm-light lg-text-md-light"
                dangerouslySetInnerHTML={{
                  __html: push?.abstractHtml,
                }}
              ></div>
            ) : push?.abstract ? (
              <div className="editorialPush__text text-sm-light lg-text-md-light">
                {push.abstract}
              </div>
            ) : null}
            {push?.linkPush && push?.labelPush && (
              <div className="editorialPush__cta">
                <Link
                  className={classNames(
                    "btn-link button",
                    push?.colour?.[0] === "white" ? "btn-link--white tertiary" : "button secondary"
                  )}
                  target={push?.targetPush?.[0]}
                  to={push?.linkPush}
                >
                  {push?.labelPush}
                </Link>
              </div>
            )}
          </div>
        </div>
        {images && (
          <div className="editorialPush__image">
            <GatsbyImage image={images} alt={push.image.value.description || ""} />
          </div>
        )}
        {typeof push?.image === "string" && (
          <div className="editorialPush__image">
            <img src={push?.image} alt={push.image.value.description || ""} />
          </div>
        )}
      </div>
    </>
  );
};

export default Push;
export const fragment = graphql`
  fragment EditorialPushFragment on LiferayEditorialPush {
    id
    liferayFields {
      siteId
      articleId
    }
    anchor {
      anchorTitleDesktopPush
    }
    push {
      pretitle
      title
      abstract
      abstractHtml
      colour
      layout
      labelPush
      linkPush
      targetPush
      image {
        value {
          description
        }
        node {
          gatsbyImageData(layout: FULL_WIDTH, breakpoints: [495, 712, 902, 1267], sizes: "66vw")
        }
        nodeMobile: node {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      colorLabelPush
    }
  }
`;
